<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  created: function() {
    let type = this.$route.query.type;

    type = type ? type.toLowerCase() : type;
    if (type == "nxt") {
      this.$store.state.walletnxt = "https://nxtblock.hebeblock.com/";
      this.$store.state.http = "https://nxt.hebeblock.com";
      this.$store.state.api = this.$store.state.http + "/nxt?";
      this.$store.state.apiText = "Nxt";
    }
    if (type == "actn") {
      this.$store.state.walletnxt = "https://actnblock.hebeblock.com/";
      this.$store.state.http = "https://actn.hebeblock.com";
      this.$store.state.api = this.$store.state.http + "/nxt?";
      this.$store.state.apiText = "Actn";
    }
    if (type == "rya") {
      this.$store.state.walletnxt = "https://ryablock.hebeblock.com/";
      this.$store.state.http = "https://rya.hebeblock.com";
      this.$store.state.api = this.$store.state.http + "/nxt?";
      this.$store.state.apiText = "Rya";
    }
    if (type == "aie") {
      this.$store.state.walletnxt = "https://ryablock.hebeblock.com/";
      this.$store.state.http = "https://aie.artiqox.com";
      this.$store.state.api = this.$store.state.http + "/nxt?";
      this.$store.state.apiText = "Aie";
    }
    if (type == "hebe" || !type) {
      this.$store.state.walletnxt = "https://hebeblock.hebeblock.com/";
      this.$store.state.http = "https://wallet.hebeblock.com";
      this.$store.state.api = this.$store.state.http + "/hebe?";
      this.$store.state.apiText = "Hebe";
    }

    this.$g.wallet.init(this.$store.state.apiText);
    this.$ajax({
      method: "get",
      url: "requestType=getConstants"
    }).then(response => {
      this.$store.state.epochBeginning = response.epochBeginning;
    });
  },
  watch: {
    $route(to, from) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          type: this.$store.state.apiText
        }
      });
    }
  }
};
</script>

<style lang="less">
.hljs {
  line-height: 1.8;
  font-family: Menlo, Monaco, Consolas, Courier, monospace;
  font-size: 12px;
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  -webkit-font-smoothing: auto;
  display: block;
  overflow-x: auto;
}
.el-form-item__content {
  word-wrap: break-word;
  word-break: normal;
}

.footer {
  background: #fafafa;
  line-height: 60px;
  text-align: center;
  color: #606266;
  a {
    color: #606266;
  }
}

.center {
  max-width: 1280px;
  margin: 0 auto !important;
}

.el-card {
  margin-top: 20px !important;
}

html,
body,
#app,
.el-container {
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.el-breadcrumb {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue